import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ContentCaption from './content_caption';
import withScriptTagExecution from '../hocs/withScriptTagExecution';
import {some, get} from 'lodash';
import {
  isVideo,
  isInstagram,
  isPinterest,
  isTwitter,
  findAspectRatioFromResource
} from '../../utils/widgetInspector';
import { external_links } from '../../utils/external_links';

export class HTMLSection extends Component {
  state = { aspectRatio: '' };

  componentDidMount() {
    if (isVideo(this.props.content.resource)) {
      this.setState({
        aspectRatio: findAspectRatioFromResource(this.props.content.resource)
      });
    }

    if (this.props.isDesktopSlideSection) {
      this.refreshEmbeds();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return some(
      ['content.resource', 'content.credit', 'content.description', 'aspectRatio'],
      key => {
        return get(this.props, key) !== get(nextProps, key)
          || get(this.state, key) !== get(nextState, key);
      }
    );
  }

  componentDidUpdate() {
    this.refreshEmbeds();
  }

  /*
   * Assorted hacks for HTML widgets that don't
   * scrape and refresh upon insertion into DOM
   */
  refreshEmbeds = () => {
    if (isInstagram(this.props.content.resource)) {
      window.instgrm && window.instgrm.Embeds.process();
      return;
    }

    if (isPinterest(this.props.content.resource)) {
      window.refreshPinterestEmbeds && window.refreshPinterestEmbeds();
      return;
    }

    if (isTwitter(this.props.content.resource)) {
      window.twttr && window.twttr.widgets.load(this._htmlContainer);
      return;
    }
  };

  contentCaption() {
    if (this.props.shouldHideContentCaption) {
      return null;
    }
    const { credit, description } = this.props.content;
    return <ContentCaption credit={credit} description={description} />;
  }

  /*
   * Since 'withScriptTagExecution' loads all <script> tags for us, we don't
   * need to insert them in the section markup...
   */
  resourceWithoutScripts() {
    /*
     * This is jQuery's regex for removing <script> tags.
     * Source: https://stackoverflow.com/a/6660315
     */
    const scriptTagRemovalRegex =
      /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    return this.props.content.resource.replace(scriptTagRemovalRegex, '');
  }

  render() {
    const containerClass = isVideo(this.props.content.resource)
      ? `video-container ratio-${this.state.aspectRatio}`
      : 'html-container';
    const html = external_links(this.resourceWithoutScripts());

    return (
      <div className="section-html">
        <div className={containerClass}
          ref={(node) => this._htmlContainer = node}
          dangerouslySetInnerHTML={{ __html: html }}
        />
        {this.contentCaption()}
      </div>
    );
  }
}

HTMLSection.propTypes = {
  content: PropTypes.shape({
    resource: PropTypes.string.isRequired,
    credit: PropTypes.string,
    description: PropTypes.string,
    alignment: PropTypes.string.isRequired,
    width_percentage: PropTypes.string
  }).isRequired,
  isDesktopSlideSection: PropTypes.bool,
  shouldHideContentCaption: PropTypes.bool
};

export default withScriptTagExecution(HTMLSection);
